import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopMediaInfoService } from '../top-media-info/top-media-info.service';

@Component({
  selector: 'mtm-asset-info-toggle',
  standalone: true,
  imports: [CommonModule],
  template: ` <i class="mtm-icon mtm-icon-topic-info pointer" (click)="toggleAssetInfo()"></i> `,
  styles: [
    `
      :host {
        display: inline-flex;
        align-items: center;
      }
    `,
  ],
})
export class AssetInfoToggleComponent {
  private readonly topMediaInfoService = inject(TopMediaInfoService);

  toggleAssetInfo(): void {
    const subsectionPreview = this.topMediaInfoService.getSubsectionPreview();
    subsectionPreview?.sliderMediaPlayerComponent?.toggleAssetInfo();
    this.topMediaInfoService.emitToggleAssetInfo();
  }
}
